<template>
  <li class="nst-menu-item">
    <div class="nst-menu-item-content">
      <v-btn
        v-if="hasChildren"
        :icon="isSubmenuOpen ? '$chevronDown' : '$chevronRight'"
        variant="plain"
        class="nst-toggle-button"
        aria-label="expand/collapse"
        @click="toggleSubmenu"
      />
      <span v-else class="nst-no-children-spacer"></span>
      <a v-if="item.uri !== `/${page.uri}`" :href="item.uri">{{ item.title }}</a>
      <span v-else> {{ item.title }} </span>
    </div>
    <ul v-if="hasChildren && isSubmenuOpen" class="nst-nested-list">
      <NestedMenuItem v-for="child in item.children" :key="child.id" :item="child" />
    </ul>
  </li>
</template>

<script setup>
import { ref, computed } from "vue";
const page = inject("page");
const props = defineProps({
  item: { type: Object, required: true },
});

const isSubmenuOpen = ref(false);

const hasChildren = computed(() => {
  return props.item.children && props.item.children.length > 0;
});

function toggleSubmenu() {
  isSubmenuOpen.value = !isSubmenuOpen.value;
}
</script>

<style scoped>
.nst-menu-item::before {
  display: none;
}
.nst-nested-list {
  list-style-type: none;
  padding-left: 20px; /* Adjust as needed for indentation */
}
.nst-menu-item-content {
  min-height: 32px; /* Adjusted for v-btn size="small" (default is 36px, small is ~32px) */
  display: flex;
  align-items: center;
}
.nst-toggle-button {
  margin-right: 4px; /* Add some space between button and text */
  /* v-btn variant="plain" size="small" is roughly 32x32px */
}
.nst-no-children-spacer {
  display: inline-block;
  width: 32px;
  height: 32px;
  margin-right: 20px; /* Match toggle button margin */
}
</style>
